export const typeRoomService = [
    { id: 1, name: 'Resident' },
    { id: 2, name: 'Office' },
    { id: 3, name: 'Shop' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeRoomService.js